import stringHelper from '../Helpers/stringHelper';

class MassMessageItem {
  constructor(selection) {
    if (!selection) {
      this.AllItemInTheSearchSetAreSelected = false;
      this.SearchItem = null;
      this.SelectedIds = [];
      this.NumberOfSelectedUsers = 0;
      this.Subject = '';
      this.Message = '';
      this.RecipientSummary = '';
      return;
    }

    this.AllItemInTheSearchSetAreSelected = selection.allItemInTheSearchSetAreSelected;
    this.SearchItem = selection.searchItem;
    this.SelectedIds = selection.selectedIds;
    this.NumberOfSelectedUsers = selection.numberOfSelectedUsers;
    this.Subject = '';
    this.Message = '';
    this.RecipientSummary = selection.allItemInTheSearchSetAreSelected
      ? `This message will be sent to all ${stringHelper.plural(selection.numberOfSelectedUsers, 'user')} in the current search set.`
      : `This message will be sent to ${stringHelper.plural(selection.numberOfSelectedUsers, 'user')}.`;
  }
}

export default MassMessageItem;
